import { render } from "./FaixaChip.vue?vue&type=template&id=7e20ad98&scoped=true"
import script from "./FaixaChip.vue?vue&type=script&lang=js"
export * from "./FaixaChip.vue?vue&type=script&lang=js"

import "./FaixaChip.vue?vue&type=style&index=0&id=7e20ad98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e20ad98"]])

export default __exports__